import { useImperativeHandle, forwardRef, useRef, useState, useEffect } from 'react'
import { Box, IconButton } from '@mui/material'
import PlayCircleIcon from '@mui/icons-material/PlayCircle'

const VideoPlayer = forwardRef(({ videoSrc }, ref) => {
  const videoRef = useRef(null)
  const [showPlayButton, setShowPlayButton] = useState(true)

  useImperativeHandle(ref, () => videoRef.current)

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play()
      setShowPlayButton(false)
    }
  }

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const handleEnded = () => setShowPlayButton(true)
    const handlePlayEvent = () => setShowPlayButton(false)

    video.addEventListener('ended', handleEnded)
    video.addEventListener('play', handlePlayEvent)

    return () => {
      video.removeEventListener('ended', handleEnded)
      video.removeEventListener('play', handlePlayEvent)
    }
  }, [])

  return (
    <Box className="testRunResultsVideoContainer">
      <video
        ref={videoRef}
        controls
        src={videoSrc}
        style={{
          width: '100%',
          maxHeight: '576px',
          borderRadius: '8px'
        }}
        preload="metadata"
        onClick={() => setShowPlayButton(false)}
      >
        Your browser does not support the video tag.
      </video>

      {showPlayButton && (
        <IconButton
          onClick={handlePlay}
          className="testRunResultsVideoPlayButton"
        >
          <PlayCircleIcon className="testRunResultsVideoPlayButtonIcon" color="#4574D2"/>
        </IconButton>
      )}
    </Box>
  )
})

VideoPlayer.displayName = 'VideoPlayer'

export default VideoPlayer